import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Spinner,
  VStack,
  Text,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const AnvaMaatwerkLoadingModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('FLOWS_PRODUCT_BASKET_MAATWERK_LOADING_TITLE')}
        </ModalHeader>
        <ModalBody>
          <VStack spacing={4} align="center" py={6}>
            <Spinner size="xl" />
            <Text>{t('FLOWS_PRODUCT_BASKET_MAATWERK_LOADING_TEXT')}</Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AnvaMaatwerkLoadingModal;
